<template>
    <div class="hello">
        <!-- <div>{{ loginUser }} AA</div>
        <div>{{ storagetest1() }} BB</div>
        <div>{{ storagetest4("userInfo") }} CC</div> -->
        <van-row>
            <van-col span="2">
                <!-- <van-button type="primary" icon="arrow-left" plain round @click="dateUp()"></van-button> -->
                <div class="container" @click="dateUp()">
                    <van-icon name="arrow-left" />
                </div>
            </van-col>
            <van-col span="20">
                <van-calendar :poppable="false" :show-confirm="false" :show-subtitle="false" :min-date="minDate"
                    :max-date="maxDate" :formatter="formatter" style="height: 510px;" @confirm="dayConfirm">
                    <template slot="title">
                        <div>工作安排({{ tenantId + '-' + loginUser.realName }})</div>
                    </template>
                </van-calendar>
            </van-col>
            <van-col span="2">
                <div class="container" @click="dateDw()">
                    <van-icon name="arrow" />
                </div>
                <!-- <van-button type="primary" icon="arrow" plain round @click="dateDw()"></van-button> -->
            </van-col>
        </van-row>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px', margin: '0'}">
            {{ dayItem != {} ? dayItem.workDay : ""}} 详情
        </van-divider>
        <div v-if="dayItem.workDay">
            <div style="padding:0 48px">
                <van-collapse v-model="activeName" accordion>
                    <van-collapse-item :title="getDayItemTitle(1)" name="1">
                        <van-cell-group inset v-if="dayItem.bookingList.length > 0 && activeName=='1'">
                            <van-cell v-for="(bkItem, bkIdx) in dayItem.bookingList" title-class="left" :key="bkIdx"
                                :title="bkItem.timePartName" :value="getBookingInfo(bkItem)" />
                        </van-cell-group>
                        <div v-else>暂无数据</div>
                    </van-collapse-item>
                    <van-collapse-item title="时段分布" name="2">
                        <van-row v-if="dayItem.workPeopleList.length > 0 && activeName=='2'">
                            <van-col span="4" v-for="(wpItem, wpIdx) in dayItem.workPeopleList" :key="wpIdx"
                                class="timeWorkCell">
                                <div>{{ wpItem.hour + "点"}}</div>
                                <div>{{ wpItem.peopleNum + "人"}}</div>
                            </van-col>
                        </van-row>
                        <div v-else>暂无数据</div>
                    </van-collapse-item>
                    <van-collapse-item title="员工排班" name="3">
                        <van-cell-group inset v-if="dayItem.workList.length > 0 && activeName=='3'">
                            <van-button icon="plus" round type="primary" style="width: 100%;"
                                @click="showUserWorkArrange()">设置详细安排</van-button>
                            <van-cell v-for="(wkItem, wkIdx) in dayItem.workList" title-class="left" :key="wkIdx"
                                :title="wkItem.name" :label="wkItem.workTimeStr"
                                :value="wkItem.userNameList.length + '人'" />
                            <!-- wkItem.userNameList.length -->
                        </van-cell-group>
                        <div v-else>暂无数据</div>
                    </van-collapse-item>
                    <van-collapse-item :title="getDayItemTitle(4)" name="4">
                        <van-cell-group inset>
                            <van-cell v-for="(wkoItem, wkoIdx) in dayItem.workOtherList" title-class="left"
                                :key="wkoIdx" :title=" wkoItem.remark" :label="wkoItem.workTimeStr"
                                :value="wkoItem.name">
                                <template #right-icon>
                                    <div class="del-hour-user">
                                        <van-button icon="delete-o" type="danger" size="small" round
                                            @click="removeHourUser(wkoItem)" />
                                    </div>
                                </template>
                            </van-cell>
                            <!-- wkItem.userNameList.length -->
                        </van-cell-group>
                        <van-button icon="plus" round type="primary" style="width: 100%;margin-top: 10px;"
                            @click="showAddHourUser()">添加钟点工</van-button>
                    </van-collapse-item>
                    <van-collapse-item :title="getDayItemTitle(5)" name="5">
                        <van-cell-group inset v-if="dayItem.addWorkList.length > 0">
                            <van-cell v-for="(awkItem, awkIdx) in dayItem.addWorkList" title-class="left" :key="awkIdx"
                                :title="awkItem.name" :label="awkItem.workTimeStr" :value="awkItem.workHour + '小时'" />
                            <!-- wkItem.userNameList.length -->
                        </van-cell-group>
                        <div v-else>暂无数据</div>
                    </van-collapse-item>
                    <van-collapse-item :title="getDayItemTitle(6)" name="6">
                        <van-cell-group inset v-if="dayItem.supplementWorkList.length > 0">
                            <van-cell v-for="(swkItem, swkIdx) in dayItem.supplementWorkList" title-class="left"
                                :key="swkIdx" :title="swkItem.name" :label="swkItem.workTimeStr"
                                :value="swkItem.workHour + '小时'" />
                            <!-- wkItem.userNameList.length -->
                        </van-cell-group>
                        <div v-else>暂无数据</div>
                    </van-collapse-item>
                </van-collapse>
            </div>
        </div>

        <van-popup v-model="addHourUserShow" round>
            <van-field label="需要人数" class="add-hour-user">
                <template #input>
                    <van-stepper v-model="hourUser.houseUserNum" />
                </template>
            </van-field>
            <van-field readonly clickable :value="hourUser.onDuty1" label="上班时间" placeholder="点击选择时间"
                @click="showSelectTime(1)" />
            <van-field readonly clickable :value="hourUser.offDuty1" label="下班时间" placeholder="点击选择时间"
                @click="showSelectTime(2)" />
            <van-field v-model="hourUser.remark" label="备注" placeholder="请输入用工需求">
                <template #button>
                    <van-button size="mini" round type="primary">选择</van-button>
                </template>
            </van-field>
            <div style="margin: 16px;">
                <van-button round block type="info" @click="saveHourUser">提交</van-button>
            </div>
        </van-popup>

        <van-popup v-model="showHourTime" position="bottom">
            <van-datetime-picker type="time" min-hour="7" max-hour="23" @confirm="timeConfirm"
                @cancel="showHourTime = false" />
        </van-popup>

        <van-popup v-model="userWorkArrangeShow" round>
             
            <van-row class="set-user-work">
                <van-col span="20">
                    {{ dayItem.workDay }} 人员分配 
                </van-col>
                <van-col span="4">
                    <van-button round type="primary" size="small" @click="copyWork()">
                       复制
                    </van-button>
                </van-col>
            </van-row>               
            
            <div class="set-user-work">
                <van-radio-group v-model="timePart" direction="horizontal">
                    <van-radio name="1">早市</van-radio>
                    <van-radio name="2">晚市</van-radio>
                </van-radio-group>
            </div>
            <van-collapse v-model="workArrangeActiveNames">
                <van-collapse-item title="一楼" name="1">
                    <div v-for="(item, idx) in userWorkInfoList1" :key="idx">
                        <!-- v-if="item.workArea == 1 && item.workTimePart == timePart" -->
                        <van-cell-group inset v-if="item.workArea == 1 && item.workTimePart == timePart">
                            <van-cell title-class="left" :title="item.workName" :label="item.userNames">
                                <template #right-icon>
                                    <div class="del-hour-user">
                                        <van-button icon="delete-o" type="danger" size="small" round @click="removeUserWorkInfo(item)" />
                                    </div>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </div>

                    <van-button icon="plus" round type="primary" size="small" style="width: 80%;"
                        @click="addWorkInfoShow(1)">
                        添加一楼工作安排
                    </van-button>
                </van-collapse-item>
                <van-collapse-item title="二楼" name="2">
                    <div v-for="(item, idx) in userWorkInfoList2" :key="idx">
                        <!-- v-if="item.workArea == 1 && item.workTimePart == timePart" -->
                        <van-cell-group inset v-if="item.workArea == 2 && item.workTimePart == timePart">
                            <van-cell title-class="left" :title="item.workName" :label="item.userNames">
                                <template #right-icon>
                                    <div class="del-hour-user">
                                        <van-button icon="delete-o" type="danger" size="small" round @click="removeUserWorkInfo(item)" />
                                    </div>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </div>
                    
                    <van-button icon="plus" round type="primary" size="small" style="width: 80%;"
                        @click="addWorkInfoShow(2)">
                        添加二楼工作安排
                    </van-button>
                </van-collapse-item>
            </van-collapse>
        </van-popup>

        <van-popup v-model="addUserWorkInfoShow" round>
            <div style="padding: 10px 30px;width: 400px;">
                员工列表
            </div>
            <van-row style="padding: 2px 30px;">
                <van-col span="8" v-for="(item, idx) in selectUserList" :key="idx">
                    <div class="work-user-list">
                        <div style="flex: 1;">{{ item.text }}</div>
                        <div style="flex: 1;">
                            <van-button icon="delete-o" type="danger" size="small" round @click="delSeleteUser(idx)" />
                        </div>
                    </div>
                </van-col>
            </van-row>

            <van-field v-model="userWorkInfo.lsUserName" center label="添加临时员工" placeholder="输入员工姓名">
                <template #button>
                    <van-button round icon="plus" size="small" type="primary" @click="addLsUser()"></van-button>
                </template>
            </van-field>
            <div style="padding: 2px 30px;">
                <van-button round block type="primary" icon="plus" size="small" @click="selectUserShow = true">
                    添加系统员工
                </van-button>
            </div>

            <van-field label="工作类型">
                <template #input>
                    <van-radio-group v-model="userWorkInfo.workClass" direction="horizontal">
                        <van-radio name="1">其它服务</van-radio>
                        <van-radio name="2">传菜部</van-radio>
                        <van-radio name="3">管理人</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field v-if="userWorkInfo.workClass == 1" v-model="userWorkInfo.workName" label="工作内容"
                placeholder="请输入工作内容,如:801">
                <!-- <template #button>
                <van-button size="mini" round type="primary">选择</van-button>
              </template> -->
            </van-field>

            <div style="padding: 5px 30px;">
                <van-button round block type="info" @click="saveWorkUserInfo">保存</van-button>
            </div>
        </van-popup>

        <van-popup v-model="selectUserShow" round position="bottom">
            <van-cascader v-model="cascaderValue" title="请选择部门员工" :options="userList" @close="selectUserShow = false"
                @finish="onFinish" />
        </van-popup>

        <van-overlay :show="loading">
            <van-loading type="spinner" class="wrapper" color="#1989fa">加载中...</van-loading>
        </van-overlay>

    </div>
</template>

<script>
    import {
        getWorkInfo,
        getDayWorkInfo,
        addHourUser,
        delHourUser
    } from '@/api/dingDing/ddUser';
    import {
        getDayWorkUserInfo,
        getWorkUserList,
        addWorkUserInfo,
        delUserWorkInfo
    } from '@/api/dingDing/ddWorkUserInfo';
    import localStorage from '@/util/storage';
    import manba from 'manba';
    import { Dialog } from 'vant';
    import { Toast } from 'vant';
    import _ from 'lodash';

    export default {
        name: 'WorkArrange',
        data() {
            return {
                list: [],
                loginUser: {},
                tenantId: "",
                dayItem: {},
                activeName: '',
                confirmDate: '',
                loading: false,
                minDate: new Date(manba().startOf(manba.MONTH)),
                maxDate: new Date(manba().endOf(manba.MONTH)),

                addHourUserShow: false,
                showHourTime: false,
                selectType: 0,
                hourUser: {
                    id: "",
                    houseUserNum: 1,
                    onDuty1: "",
                    offDuty1: "",
                    remark: ""
                },

                userWorkArrangeShow: false,
                addUserWorkInfoShow: false,
                workArrangeActiveNames: ['1', '2'],
                timePart: "1",
                userWorkInfo: {
                    workTimePart: 1,
                    workClass: '1',
                    workName: '',
                    workArea: 1,
                    lsUserName: ''
                },
                userWorkInfoList1: [],
                userWorkInfoList2: [],
                selectUserShow: false,
                cascaderValue: '',
                // 选项列表，children 代表子选项，支持多级嵌套
                userList: [],
                selectUserList: [],
            };
        },
        created() {
            this.tenantId = localStorage.getLocal("tenantId");
            this.loginUser = localStorage.getLocal("userInfo");
            this.onLoad();
            // console.log("56", manba().endOf(manba.MONTH).format("f"))
            
        },
        methods: {
            // storagetest1() {
            //    return localStorage.getLocal("userInfo")  
            // },
            // storagetest4(name) {
            //    if (window.localStorage && JSON && name) {
            //      return true;
            //    }
            //    return false
            // },
            onLoad() {
                this.getMonthList();
                this.getDayList(manba().format());
            },
            getMonthList() {
                this.list = [];
                let monthData = {
                    startTime: manba(this.minDate).format(),
                    endTime: manba(this.maxDate).format(),
                    tenantId: this.tenantId,
                };
                this.loading = true;
                getWorkInfo(monthData).then((res) => {
                        if (res.status == 200 && res.data.code == 200) {
                            this.list = res.data.data;
                        }
                    })
                    .catch((e) => {
                        Toast.fail(e.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getDayList(date) {
                this.dayItem = {};
                let dayData = {
                    startTime: date,
                    endTime: date,
                    tenantId: this.tenantId,
                };
                this.loading = true;
                getDayWorkInfo(dayData).then((res) => {
                        if (res.status == 200 && res.data.code == 200) {
                            this.dayItem = res.data.data;
                        }
                    })
                    .catch((e) => {
                        Toast.fail(e.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getDayItemTitle(type) {
                if (type == 1) {
                    let bookingNum = 0;
                    let tableNum = 0;
                    // console.log("getDayItemTitle", this.dayItem.bookingList);
                    for (let i = 0; i < this.dayItem.bookingList.length; i++) {
                        bookingNum += this.dayItem.bookingList[i].bookingNum;
                        tableNum += this.dayItem.bookingList[i].tableNum;
                    }
                    if (this.dayItem.bookingList.length > 0) {
                        return "预订概况" + "(" + bookingNum + "单" + tableNum + "桌)";
                    } else {
                        return "预订概况";
                    }
                }
                if (type == 4) {
                    let houseUserNum = 0;
                    // console.log("getDayItemTitle-4", this.dayItem.workOtherList);
                    for (let i = 0; i < this.dayItem.workOtherList.length; i++) {
                        houseUserNum += this.dayItem.workOtherList[i].houseUserNum;
                    }
                    if (this.dayItem.workOtherList.length > 0) {
                        return "钟点工" + "(" + houseUserNum + "人)";
                    } else {
                        return "钟点工";
                    }
                }
                if (type == 5) {
                    let workHour = 0;
                    // console.log("getDayItemTitle-5", this.dayItem.addWorkList);
                    for (let i = 0; i < this.dayItem.addWorkList.length; i++) {
                        workHour += Number(this.dayItem.addWorkList[i].workHour);
                    }
                    if (this.dayItem.addWorkList.length > 0) {
                        return "加班" + "(" + workHour + "小时)";
                    } else {
                        return "加班";
                    }
                }
                if (type == 6) {
                    let workHour = 0;
                    // console.log("getDayItemTitle-6", this.dayItem.supplementWorkList);
                    for (let i = 0; i < this.dayItem.supplementWorkList.length; i++) {
                        workHour += Number(this.dayItem.supplementWorkList[i].workHour);
                    }
                    if (this.dayItem.supplementWorkList.length > 0) {
                        return "补钟" + "(" + workHour + "小时))";
                    } else {
                        return "补钟";
                    }
                }
            },
            dateUp() {
                this.minDate = new Date(manba(this.minDate).add(-1, manba.MONTH));
                this.maxDate = new Date(manba(this.maxDate).add(-1, manba.MONTH).endOf(manba.MONTH));
                // this.getMonthList();
                this.dateUpDw();
            },
            dateDw() {
                this.minDate = new Date(manba(this.minDate).add(1, manba.MONTH));
                this.maxDate = new Date(manba(this.maxDate).add(1, manba.MONTH).endOf(manba.MONTH));
                // this.getMonthList();
                this.dateUpDw();
            },
            dateUpDw: _.debounce(function() {
                console.log("456")
                this.getMonthList();
            }, 1000, {
                leading: false,
                trailing: true
            }, ),
            formatter(day) {
                let toDate = day.date.getDate();
                let item = this.list[toDate - 1];
                if (item && item.dayOfMonth == toDate) {
                    day.topInfo = item.chineseCalendar;
                    day.bottomInfo = "";
                    if (item.bookingTableNum > 0) {
                        day.bottomInfo += '预' + item.bookingTableNum + " "
                    }
                    if (item.userTotal > 0) {
                        day.bottomInfo += '工' + item.workUserNum;
                    }
                }
                return day;
            },
            dayConfirm(date) {
                this.confirmDate = manba(date).format();
                this.getDayList(this.confirmDate);
                console.log("dayConfirm", this.confirmDate);
            },
            getBookingInfo(item) {
                return "预定数：" + item.bookingNum + " 桌数：" + item.tableNum;
            },
            // 钟点工
            showAddHourUser() {
                this.hourUser = {
                    id: "",
                    houseUserNum: 1,
                    onDuty1: "",
                    offDuty1: "",
                    remark: ""
                };
                this.addHourUserShow = true;
            },
            showSelectTime(type) {
                this.showHourTime = true;
                this.selectType = type;
                console.log(type);
            },
            timeConfirm(date) {
                console.log("timeConfirm", date);
                if (this.selectType == 1) {
                    this.hourUser.onDuty1 = date;
                }
                if (this.selectType == 2) {
                    this.hourUser.offDuty1 = date;
                }
                this.showHourTime = false;
            },
            saveHourUser() {
                if (this.hourUser.houseUserNum < 1) {
                    Toast.fail('请输入钟点工人数');
                    return;
                }
                if (this.hourUser.onDuty1 == '' || this.hourUser.onDuty1 == null) {
                    Toast.fail('请输入上班时间');
                    return;
                }
                if (this.hourUser.offDuty1 == '' || this.hourUser.offDuty1 == null) {
                    Toast.fail('请输入下班时间');
                    return;
                }
                if (this.hourUser.remark == '' || this.hourUser.remark == null) {
                    Toast.fail('请输入用工说明');
                    return;
                }

                let addData = {
                    id: this.hourUser.id,
                    houseUserNum: this.hourUser.houseUserNum,
                    onDuty1: this.dayItem.workDay + " " + this.hourUser.onDuty1 + ":00",
                    offDuty1: this.dayItem.workDay + " " + this.hourUser.offDuty1 + ":00",
                    workDay: this.dayItem.workDay,
                    remark: this.hourUser.remark,
                    tenantId: this.tenantId,
                };

                addHourUser(addData).then((res) => {
                        if (res.status == 200 && res.data.code == 200) {
                            this.getDayList(this.dayItem.workDay);
                            Toast.success('钟点工添加成功');
                            this.showHourTime = false;
                            this.addHourUserShow = false;
                        }
                    })
                    .catch((e) => {
                        Toast.fail(e.message);
                    });
            },
            removeHourUser(hourUser) {
                Dialog.confirm({
                        title: '确认删除',
                        message: '确认删除此数据吗',
                    })
                    .then(() => {
                        let delData = {
                            id: hourUser.id,
                            tenantId: this.tenantId,
                        };

                        delHourUser(delData).then((res) => {
                                if (res.status == 200 && res.data.code == 200) {
                                    this.getDayList(this.dayItem.workDay);
                                    Toast.success('钟点工删除成功');
                                } else {
                                    Toast.fail('钟点工删除失败');
                                }
                        })
                    })
                    .catch(() => {
                    })
            },
            // 服务部排班安排
            showUserWorkArrange() {
                // 加载当日工作安排
                let getData = {
                    startTime: this.dayItem.workDay,
                    tenantId: this.tenantId,
                };

                getDayWorkUserInfo(getData).then((res) => {
                        if (res.status == 200 && res.data.code == 200) {
                            this.userWorkInfoList1 = res.data.data.workUserInfo1List;
                            this.userWorkInfoList2 = res.data.data.workUserInfo2List;
                            this.userWorkArrangeShow = true;
                        } else {
                            Toast.fail('查询工作安排失败');
                        }
                    })
                    .catch((e) => {
                        Toast.fail(e.message);
                    });

            },
            addWorkInfoShow(type) {
                this.userWorkInfo = {
                    workTimePart: this.timePart,
                    workClass: '1',
                    workName: '',
                    workArea: type,
                    lsUserName: ''
                };
                this.selectUserList = [];
                this.getUserList();
            },
            getUserList() {
                if (this.userList.length == 0) {
                    //获取员工
                    let getData = {
                        startTime: this.dayItem.workDay,
                        tenantId: this.tenantId,
                    };
                    getWorkUserList(getData).then((res) => {
                        console.log("getWorkUserList", res);
                        if (res.status == 200 && res.data.code == 200) {
                            this.userList = res.data.data;
                            this.addUserWorkInfoShow = true;
                        } else {
                            Toast.fail('查询员工失败');
                        }
                    })
                } else {
                    this.addUserWorkInfoShow = true;
                }
            },
            onFinish({selectedOptions}) {
                console.log("onFinish", selectedOptions)
                // this.fieldValue = selectedOptions.map((option) => option.text).join('/');
                this.selectUserList.push(selectedOptions[selectedOptions.length - 1]);
                this.selectUserShow = false;
            },
            delSeleteUser(idx) {
                this.selectUserList.splice(idx, 1);
            },
            addLsUser() {
                if (this.userWorkInfo.lsUserName && this.userWorkInfo.lsUserName.length > 0) {
                    this.selectUserList.push({
                        text: this.userWorkInfo.lsUserName,
                        value: -1
                    });
                    this.userWorkInfo.lsUserName = "";
                }
            },
            saveWorkUserInfo() {
                if(this.selectUserList.length == 0) {
                    Toast.fail('请选择或输入员工');
                    return;
                }
                if(this.userWorkInfo.workClass == 1 && this.userWorkInfo.workName == "") {
                    Toast.fail('其它服务请输入工作内容');
                    return;
                }
                
                this.userWorkInfo.userList = this.selectUserList;
                this.userWorkInfo.tenantId = this.tenantId;
                this.userWorkInfo.startTime = this.dayItem.workDay;
                // console.log("saveWorkUserInfo", this.userWorkInfo)
                this.loading = true;
                addWorkUserInfo(this.userWorkInfo).then((res) => {
                        if (res.status == 200 && res.data.code == 200) {
                            //this.dayItem = res.data.data;
                            //添加成功
                            this.showUserWorkArrange();
                            this.addUserWorkInfoShow = false;
                        }
                    })
                    .catch((e) => {
                        Toast.fail(e.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            removeUserWorkInfo(item) {
                console.log("delUserWorkInfo", item);
                Dialog.confirm({
                        title: '确认删除',
                        message: '确认删除此数据吗',
                    })
                    .then(() => {
                        let delData = {
                            id: item.id,
                            tenantId: this.tenantId,
                        };
                
                        delUserWorkInfo(delData).then((res) => {
                                if (res.status == 200 && res.data.code == 200) {
                                    this.showUserWorkArrange(); 
                                    Toast.success('删除成功');
                                } else {
                                    Toast.fail('删除失败');
                                }
                        })
                    })
                    .catch(() => {
                    })
            },
            copyWork() {
                let msg = "";
                let space = "    ";
                let rowSign = '\n'
                if(this.timePart == 1) {
                    msg += "服务部人员安排明细" + rowSign;
                    msg += "日期：" + this.dayItem.workDay + rowSign;
                    msg += "中餐" + rowSign;
                    msg += "排班人：" + this.loginUser.realName + rowSign;
                    msg += "二楼:：" + rowSign;
                    for(let i = 0; i < this.userWorkInfoList2.length; i++) {
                        let workInfo = this.userWorkInfoList2[i];
                        if(workInfo.workTimePart == 1) {
                             msg += space +  workInfo.workName + ":" + workInfo.userNames + rowSign;
                        }
                    }
                    
                    msg += "一楼:：" + rowSign;
                    for(let i = 0; i < this.userWorkInfoList1.length; i++) {
                        let workInfo = this.userWorkInfoList1[i];
                        if(workInfo.workTimePart == 1) {
                             msg += space +  workInfo.workName + ":" + workInfo.userNames + rowSign;
                        }
                    }
                } 
                else {
                    //晚市 
                    msg += "服务部人员安排明细" + rowSign;
                    msg += "日期：" + this.dayItem.workDay + rowSign;
                    msg += "晚餐" + rowSign;
                    msg += "排班人：" + this.loginUser.realName + rowSign;
                    msg += "二楼:：" + rowSign;
                    for(let i = 0; i < this.userWorkInfoList2.length; i++) {
                        let workInfo = this.userWorkInfoList2[i];
                        if(workInfo.workTimePart == 2) {
                             msg += space +  workInfo.workName + ":" + workInfo.userNames + rowSign;
                        }
                    }
                    
                    msg += "一楼:：" + rowSign;
                    for(let i = 0; i < this.userWorkInfoList1.length; i++) {
                        let workInfo = this.userWorkInfoList1[i];
                        if(workInfo.workTimePart == 2 ) {
                             msg += space +  workInfo.workName + ":" + workInfo.userNames + rowSign;
                        }
                    }
                }         
                       
                const textArea = document.createElement('textarea');
                textArea.value = msg;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                // document.execCommand('copy');
                // document.body.removeChild(input);       
                var successful = document.execCommand('copy');
                if(successful) {
                   Toast.success('复制成功'); 
                } else {
                   Toast.fail('复制失败');
                }
                document.body.removeChild(textArea);       
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .center {
        text-align: center;
        justify-content: center;

    }

    .left {
        text-align: left;
    }

    .container {
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        height: 510px;
        /* 容器高度，例如视窗高度 */
    }

    .timeWorkCell {
        border: 1px red;
    }

    .add-hour-user {
        width: 400px;
    }

    .del-hour-user {
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        padding-left: 20px;
    }

    .work-user-list {
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        margin-bottom: 5px;
        color: #646566;
        word-wrap: break-word;
        font-size: 14px;
        line-height: 24px;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .set-user-work {
        width: 400px;
        padding: 10px 0px;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
    }
</style>
